import {
    CHANGE_SIM_PROVIDER_REQUEST,
    CHANGE_SIM_PROVIDER_RESULT,
    CHANGE_SIM_PROVIDER_OPEN_MODAL,
    CHANGE_SIM_PROVIDER_CLOSE_MODAL,
    CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST,
    CHANGE_SIM_PROVIDER_GET_DEVICE_RESULT,
    CHANGE_SIM_PROVIDER_SET_DEVICE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    devices: [],
    selectedDevices: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CHANGE_SIM_PROVIDER_REQUEST:
            return { ...state, loading: true }

        case CHANGE_SIM_PROVIDER_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CHANGE_SIM_PROVIDER_OPEN_MODAL:
            return { ...state, openModal: true, selectedDevices: action.payload }

        case CHANGE_SIM_PROVIDER_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case CHANGE_SIM_PROVIDER_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case CHANGE_SIM_PROVIDER_SET_DEVICE:
            return { ...state, devices: action.payload }


        case CLEAR_REDUX:
            return ["", "CHANGE_SIM_PROVIDER"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};